var React = require('react');

function Xcreatives (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".x-creatives-svg-1{fill:#fff;}")),React.createElement("path",{"className":"x-creatives-svg-1","d":"M4.71,4,7.89.82a.51.51,0,0,0,0-.71.51.51,0,0,0-.71,0L4,3.29.82.11a.51.51,0,0,0-.71,0,.51.51,0,0,0,0,.71L3.29,4,.11,7.18a.51.51,0,0,0,0,.71.51.51,0,0,0,.71,0L4,4.71,7.18,7.89a.5.5,0,1,0,.71-.71Z","key":1})]);
}

Xcreatives.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 8 8"};

module.exports = Xcreatives;

Xcreatives.default = Xcreatives;
